
import translations from './ProductCard.translations'

const MAX_TAGS = 3

export default {
  props: {
    storages: { type: Array, default: () => [] },
    maxTags: { type: Number, default: MAX_TAGS },
  },
  computed: {
    translations: () => translations,
    validStorages() {
      return this.storages.filter((value) => typeof value === 'string')
    },
    filteredStorages() {
      return this.validStorages.slice(0, this.maxTags)
    },
    remainingStoragesLength() {
      return this.validStorages.length - this.filteredStorages.length
    },
  },
}
